module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#t1",
      "id": "c1"
    }
  }, [_c('i', [_vm._v("dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc0"
  }, [_vm._v("This book is dedicated to Hank Williams, Jr.,")]), _vm._v(" "), _c('p', {
    staticClass: "txc0"
  }, [_vm._v("who told me to “Saddle up, and go for it.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 63
// module chunks = 0